import { concatClassnames } from "shared/utils/concatClassnames";

export enum CheckboxVariant {
  ROUND,
  SQUARE,
}

const CHECKBOX_VARIANT_RECORD: Record<CheckboxVariant, string> = {
  [CheckboxVariant.ROUND]:
    "gg-w-4 gg-h-4 gg-border gg-border-dark-blue-300 checked:!gg-bg-emerald gg-rounded-full",
  [CheckboxVariant.SQUARE]:
    "gg-w-4 gg-h-4 gg-border gg-border-dark-blue-300 gg-rounded-sm",
};

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  id?: string;
  variant?: CheckboxVariant;
  etc?: any;
}
const Checkbox = ({
  className = "",
  id,
  onChange,
  checked,
  variant = CheckboxVariant.SQUARE,
  ...etc
}: CheckboxProps) => {
  return (
    <input
      type="checkbox"
      id={id}
      checked={checked}
      onChange={onChange}
      className={concatClassnames(
        "gg-border",
        CHECKBOX_VARIANT_RECORD[variant],
        className,
      )}
      {...etc}
    ></input>
  );
};
export default Checkbox;
